<app-popover-secondary (closeCallback)="cancelCallback()" [customStyle]="'cab-track'"  >
  <ng-container popover-content style="border: 5px solid red;">
    <div class="header">
      <div>
        Track
      </div>
    </div>
    <div id="stop-location-map"></div>
    <app-map-controls *ngIf="map" [trafficControl]="false" [focusControl]="false" (focusCallback)="focusMap()"
      [map]="map"></app-map-controls>
  </ng-container>
</app-popover-secondary>